/**
 * Origem da execução da Tabela IBPT. Mesmos ids do catálogo db_motor_fiscal.ibpt_origem_execucao.
 */
export enum IbptOrigemExecucaoEnum {
    Api = 1,
    Planilha = 2,
}
